import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { Ayuda } from "./Glosario";

const cache = new Map();
const subs = new Set();
let version = 0;
export const invalidarBanderas = () => { cache.clear(); version += 1; subs.forEach((f) => f(version)); };
const valido = (d) => !!String(d || "").replace(/\D/g, "").replace(/^0+/, "");
const pedir = (nombre, documento) => {
  const k = `${documento}|${nombre}`;
  if (!cache.has(k)) {
    cache.set(k, api.post("/portal/ruc-banderas", { pares: [{ nombre, documento }] }).then((r) => r.data.items[0] || []).catch(() => { cache.delete(k); return []; }));
  }
  return cache.get(k);
};

/** Alerta de verificación cuando el nombre del catastro y el RUC probablemente no se corresponden (no modifica el dato). */
export function BanderaRuc({ nombre, documento, testid = "bandera-ruc" }) {
  const [fl, setFl] = useState([]);
  const [v, setV] = useState(version);
  useEffect(() => { subs.add(setV); return () => { subs.delete(setV); }; }, []);
  useEffect(() => {
    let vivo = true;
    if (valido(documento)) { pedir(nombre, documento).then((x) => { if (vivo) setFl(x); }); } else { setFl([]); }
    return () => { vivo = false; };
  }, [nombre, documento, v]);
  if (!fl.length) return null;
  return <div className="space-y-1 my-1" data-testid={testid}>
    {fl.map((f) => <p key={f.tipo} className="flex items-start gap-1.5 rounded-md border border-amber-300 bg-amber-50 px-2 py-1 text-[11px] text-amber-900 font-medium" data-testid={`${testid}-${f.tipo}`}>
      <AlertTriangle className="w-3.5 h-3.5 mt-0.5 shrink-0 text-amber-600" /><span>{f.texto}<Ayuda k="ruc_inconsistente" /></span></p>)}
  </div>;
}
